import React, { forwardRef } from "react";
import { Stack } from "@mui/material";

interface ContentAreaWrapperProps {
    children: React.ReactNode;
    fullyScrollable?: boolean; // Determines scroll behavior for the wrapper
    headerType?: "main" | "tab" | "none"; // Determines top padding
    noFooter?: boolean; // Disables bottom padding
    stickyBottomButton?: boolean; // Enlarges bottom padding
}

const ContentAreaWrapper = forwardRef<HTMLDivElement, ContentAreaWrapperProps>(
    (
        {
            children,
            fullyScrollable = true,
            headerType = "main",
            noFooter = false,
            stickyBottomButton = false,
            ...rest
        },
        ref
    ) => {
        const paddingTop = {
            main: "72px",
            tab: "20px",
            none: 0,
        };

        const calculatePb = (
            footer: boolean,
            stickyBottomButton: boolean
        ): string => {
            const basicPb = "4vh";
            const footerSize = "90px";
            const bottomButtonSize = "16vh";

            const parts = [basicPb];
            if (footer) parts.push(footerSize);
            if (stickyBottomButton) parts.push(bottomButtonSize);

            return `calc(${parts.join(" + ")})`;
        };

        return (
            <Stack
                ref={ref}
                direction="column"
                width="100%"
                height="100%"
                justifyContent="start"
                alignItems="center"
                spacing={2.5}
                px={2}
                sx={{
                    overflowY: fullyScrollable ? "auto" : "hidden",
                    overflowX: "hidden",
                    boxSizing: "border-box",
                    paddingTop: paddingTop[headerType], // Add space for the fixed header
                    paddingBottom: calculatePb(!noFooter, stickyBottomButton),
                    "@keyframes fadeSlideIn": {
                        from: { opacity: 0, transform: "translateY(12px)" },
                        to: { opacity: 1, transform: "translateY(0)" },
                    },
                    animation: "fadeSlideIn 0.3s ease-out",
                }}
            >
                {children}
            </Stack>
        );
    }
);

export default ContentAreaWrapper;
